"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentNameTranslation = exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["dev"] = "dev";
    Environment["int"] = "int";
    Environment["test"] = "test";
    Environment["dogfood"] = "dogfood";
    Environment["prod"] = "prod";
    Environment["gcc"] = "gcc";
    Environment["dod"] = "dod";
    Environment["gccHigh"] = "gcchigh";
})(Environment = exports.Environment || (exports.Environment = {}));
/* eslint-disable-next-line @typescript-eslint/naming-convention */
exports.EnvironmentNameTranslation = {
    gcc: 'fairfax'
};
//# sourceMappingURL=iLambdaConfigRegistry.js.map